import { useState, useRef, useCallback, useEffect } from 'react';

var useEodCallback = function (cb) {
    var _a = useState(null), hash = _a[0], setHash = _a[1];
    var ref = useRef(document.getElementById('single-spa-application:@nautilusjs/app-shared'));
    /**
     * observer callback which will be called
     * only when there is a ref.current
     */
    var observerCb = useCallback(function () {
        var _a;
        if (!hash) {
            return;
        }
        if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.hasChildNodes())) {
            cb(hash);
        }
    }, [hash, ref, cb]);
    var eventCb = useCallback(function (event) {
        var _a = event.detail, type = _a.type, hash = _a.hash;
        // we only care about eod
        if (type !== 'eod' || !(hash === null || hash === void 0 ? void 0 : hash.id)) {
            return;
        }
        // set hash so we can use it later
        setHash(hash.id);
    }, [setHash]);
    /**
     * here we are adding a observer to
     * app-shared, and calling observer
     * callback whenever something changes
     */
    useEffect(function () {
        if (!ref.current) {
            return;
        }
        // setup observer
        var observer = new MutationObserver(observerCb);
        // call observe on ref.current, we only care about childList
        observer.observe(ref.current, { childList: true });
        return function () {
            // disconnect observer
            observer.disconnect();
        };
    }, [ref, observerCb]);
    /**
     * add event listener to @maui:drawer-open just
     * so we can store the hash and later use it
     */
    useEffect(function () {
        document.addEventListener('@maui:drawer-open', eventCb);
        return function () {
            document.removeEventListener('@maui:drawer-open', eventCb);
        };
    }, [eventCb]);
};

var useEodDrawer = function () {
    var ref = useRef(document.querySelector('#nautilusjs-eod-drawer'));
    var open = useCallback(function (payload) {
        var _a;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.hasChildNodes()) {
            closeDrawer();
            setImmediate(function () { return openDrawer(payload); });
            return;
        }
        openDrawer(payload);
    }, []);
    var openDrawer = useCallback(function (payload) {
        document.dispatchEvent(new CustomEvent('@maui:drawer-open', {
            detail: {
                type: 'eod',
                hash: payload
            }
        }));
        /**
         * Temporary:
         * Will be removed once EOD
         * team fixes drawer positioning
         *
         */
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
    var closeDrawer = useCallback(function () {
        document.dispatchEvent(new CustomEvent('@maui:drawer-close', {
            detail: {
                type: 'eod'
            }
        }));
    }, []);
    return open;
};

export { useEodCallback, useEodDrawer };
